import angular from 'angular';

angular.module('vrm.components').service('InstallationAvatarService', InstallationAvatarService);

/* @ngInject */
function InstallationAvatarService(
    VrmModalService,
    ApiService,
    $log
) {
    const service = {
        openAvatarModal,
    };


    function openAvatarModal(scope, installation) {
        if (!installation.view_permissions.update_settings) {
            return;
        }
        VrmModalService.openUploadModal(scope, 'avatar', async function (files) {
            if (!files && files.length !== 1) return;

            const data = new FormData();
            data.append('data', files[0]);
            data.append('is_avatar', '1');
            ApiService.installationUploadPhoto(installation.idSite, data)
                .then((response) => {
                    if (response.data && response.data['url']) {
                        installation.avatar_url = response.data['url'];
                    }
                })
                .catch((error) => {
                    $log.error("Error uploading photo", error);
                });
        });
    }
    return service;
}
